var _excluded = ["alt", "className", "handleError", "handleLoad", "height", "resource", "type", "width", "widths", "ratio"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { func, instanceOf, number, oneOfType, string } from 'prop-types';
import { useResourceImage } from '@magento/peregrine/lib/talons/Image/useResourceImage';
import { generateSrcset, generateUrl } from '@magento/peregrine/lib/util/imageUtils';

/**
 * Renders a Magento resource image.
 *
 * @param {string}   props.alt the alt attribute to apply to the image.
 * @param {string}   props.className the class to apply to this image.
 * @param {Func}     props.handleError the function to call if the image fails to load.
 * @param {Func}     props.handleLoad the function to call if the image successfully loads.
 * @param {number}   props.height the height to request for the fallback image for browsers that don't support srcset / sizes.
 * @param {string}   props.resource the Magento path to the image ex: /v/d/vd12-rn_main_2.jpg
 * @param {string}   props.type the Magento image type ("image-category" / "image-product"). Used to build the resource URL.
 * @param {number}   props.width the intrinsic width of the image & the width to request for the fallback image for browsers that don't support srcset / sizes.
 * @param {Map}      props.widths a map of breakpoints to possible widths used to create the img's sizes attribute.
 * @param {number}   props.ratio is the image width to height ratio. Defaults to 4/5.
 */
var ResourceImage = props => {
  var {
      alt,
      className,
      handleError,
      handleLoad,
      height,
      resource,
      type,
      width,
      widths,
      ratio
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  var talonProps = useResourceImage({
    generateSrcset,
    generateUrl,
    height,
    resource,
    type,
    width,
    widths,
    ratio
  });
  var {
    sizes,
    src,
    srcSet
  } = talonProps;

  // Note: Attributes that are allowed to be overridden must appear before the spread of `rest`.
  return /*#__PURE__*/React.createElement("img", _extends({
    loading: "lazy"
  }, rest, {
    alt: alt,
    className: className,
    onError: handleError,
    onLoad: handleLoad,
    sizes: sizes,
    src: src,
    srcSet: srcSet,
    width: width
  }));
};
ResourceImage.propTypes = {
  alt: string.isRequired,
  className: string,
  handleError: func,
  handleLoad: func,
  resource: string.isRequired,
  height: oneOfType([number, string]),
  type: string,
  width: oneOfType([number, string]),
  widths: instanceOf(Map)
};
ResourceImage.defaultProps = {
  type: 'image-product'
};
export default ResourceImage;